import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Avatar, Button, Menu, MenuItem, TextField } from "@mui/material";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SchoolIcon from "@mui/icons-material/School";
import BackupIcon from "@mui/icons-material/Backup";
import BioDataForm from "../AccountHelper/BioDataForm";
import BankDetailsForm from "../AccountHelper/BankDetailsForm";
import InstituteForm from "../AccountHelper/InstituteForm";
import DocumentsForm from "./DocumentsForm";
import { useState } from "react";

export default function AccountHelperForm() {
  const [value, setValue] = React.useState("1");

  const [formData, setFormData] = useState({ applyingFor: "" });

  const handleInputChange = (e) => {
    const { value } = e.target;
    setFormData({ ...formData, property: value });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const applicationType = [
    "Undergraduate Indigene",
    "Postgraduate Indigene",
    "Undergraduate Resident",
    "Postgraduate Resident",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        typography: "body1",
        height: "36rem",
        overflow: "auto",
      }}
    >
      {/* Profile preview section */}
      <div className="flex justify-between items-center w-full p-3">
        <div className="preview-con flex  w-full p-3">
          <div className=" w-1/6">
            <Avatar
              alt="Remy Sharp"
              src="/kd.png"
              sx={{ width: 100, height: 100 }}
            />
          </div>

          <div className=" w-3/6 ">
            <p>
              <b>Name:</b> <span>Sadeeq Fahass</span>
            </p>
            <p>
              <b>Email:</b> <span>SadeeqFahass@gmail.com</span>
            </p>
            <p>
              <b>Institute:</b> <span>KASU</span>
            </p>
            <p>
              <b>Matric No:</b> <span>15CIS021</span>
            </p>
          </div>
        </div>

        <div className="w-3/6 buttons flex items-center gap-2 h-8">
          <TextField
            select
            label="Application Type"
            name="applyingFor"
            value={formData.applyingFor}
            onChange={handleInputChange}
            fullWidth
          >
            {applicationType.map((item, index) => (
              <MenuItem
                sx={{ whiteSpace: "break-spaces" }}
                key={index}
                value={item}
              >
                {item}
              </MenuItem>
            ))}
          </TextField>
          <Button variant="contained">Submit</Button>
        </div>
      </div>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab
              label="Bio Data"
              value="1"
              icon={<FolderSharedIcon />}
              iconPosition="start"
            />
            <Tab
              label="Bank Details"
              value="2"
              icon={<AccountBalanceIcon />}
              iconPosition="start"
            />
            <Tab
              label="Institute"
              value="4"
              icon={<SchoolIcon />}
              iconPosition="start"
            />
            <Tab
              label="Documents"
              value="5"
              icon={<BackupIcon />}
              iconPosition="start"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          <BioDataForm />
        </TabPanel>
        <TabPanel value="2">
          <BankDetailsForm />
        </TabPanel>
        <TabPanel value="3"></TabPanel>
        <TabPanel value="4">
          <InstituteForm />
        </TabPanel>
        <TabPanel value="5">
          <DocumentsForm />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
